<template>
  <div>
    <h4 class="sr-only">{{ title }}</h4>
    <div aria-hidden="true">
      <div class="bg-gray-200 overflow-hidden">
        <transition appear @before-appear="beforeEnter" @after-appear="enter">
          <div class="bg-secondary h-0.75 transition-width duration-500 w-0" :style="`width: ${updatePercentage()}%`" />
        </transition>
      </div>
      <div class="hidden sm:grid grid-cols-4 text-sm font-medium text-gray-600">
        <div v-for="step in steps" :key="step.code" class="">
          <span class="sr-only">
            {{ step.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type Step = {
  title: string
  code: string
}

const props = defineProps<{ steps: Step[]; currentStepCode?: string; title?: string }>()

const beforeEnter = (el: Element) => {
  const element = el as HTMLElement
  element.style.width = '0'
}

const enter = (el: Element) => {
  const element = el as HTMLElement
  element.style.width = `${updatePercentage()}%`
}

const updatePercentage = () => {
  const totalStepsCount = props.steps.length
  const currentStepCodeIndex = props.steps.findIndex(step => step.code === props.currentStepCode)

  if (currentStepCodeIndex === -1) return 0

  return (currentStepCodeIndex / totalStepsCount) * 100
}
</script>
